import { doc, deleteDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";

type Params = {
  faqGroupId: string;
  faqId: string;
};

export const deleteFaq = async (params: Params): Promise<void> => {
  const faqRef = doc(db, `faqGroups/${params.faqGroupId}/faqs/${params.faqId}`);
  await deleteDoc(faqRef);
};
